var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewImageBox',{attrs:{"src":_vm.data.file.url,"width":_vm.imageSize.width,"height":_vm.imageSize.height,"alt":_vm.data.caption,"max-width":_vm.imageSize.width,"image-params":_vm.imageParameters,"center-image":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }